import getAlternativeProjects, {
  AlternativeProjectResource,
} from 'src/helpers/api/alternativeProjects';
import { AppState } from 'src/redux/modules';
import { Dispatch } from 'redux';

export interface AlternativeProjectsRequestAction {
  type: 'ALTERNATIVE_PROJECTS_REQUEST';
  payload: { id: string };
}

export interface AlternativeProjectsSuccessAction {
  type: 'ALTERNATIVE_PROJECTS_SUCCESS';
  payload: any;
}

export interface AlternativeProjectsFailureAction {
  type: 'ALTERNATIVE_PROJECTS_FAILURE';
  error: true;
  payload: Error;
}

export function loadAlternativeProjects(id: string) {
  return async (dispatch: Dispatch<AppState>) => {
    dispatch({ type: 'ALTERNATIVE_PROJECTS_REQUEST', payload: { id } });

    try {
      const data = await getAlternativeProjects(id);

      dispatch<AlternativeProjectsSuccessAction>({
        type: 'ALTERNATIVE_PROJECTS_SUCCESS',
        payload: data,
      });
    } catch (error) {
      dispatch<AlternativeProjectsFailureAction>({
        type: 'ALTERNATIVE_PROJECTS_FAILURE',
        error: true,
        payload: error,
      });
    }
  };
}

export interface AlternativeProjectEventData {
  projectId: string;
  cardRank: number;
  cardCount: number;
  cardUrl: string;
}

export function clickOnAlternativeProjectCard(
  details: AlternativeProjectEventData
) {
  return {
    type: 'CLICK_ON_ALTERNATIVE_PROJECTS_CARD',
    meta: {
      analytics: {
        event: 'card click',
        subtype: 'stories you may like',
        page_section: 'stories you may like',
        content_type: 'crowdfunding_guid',
        card_id: details.projectId,
        card_rank: details.cardRank,
        card_count: details.cardCount,
        card_url: details.cardUrl,
        version_id: '1',
        version_type: 'stories you may like',
        actor_sources: 'match score',
        activity_type: 'project interestingness score',
        request_id: '',
        request_type: 'matching API',
      },
    },
  };
}

export function renderAlternativeProjectCard(
  details: AlternativeProjectEventData
) {
  return {
    type: 'RENDER_ALTERNATIVE_PROJECT_CARD',
    meta: {
      analytics: {
        event: 'card rendered',
        subtype: 'stories you may like',
        page_section: 'stories you may like',
        content_type: 'crowdfunding_guid',
        card_id: details.projectId,
        card_rank: details.cardRank,
        card_count: details.cardCount,
        version_id: '1',
        version_type: 'stories you may like',
        actor_sources: 'match score',
        activity_type: 'project interestingness score',
        request_id: '',
        request_type: 'matching API',
      },
    },
  };
}

export interface AlternativeProjectsState {
  items: AlternativeProjectResource[];
  isRequesting: boolean;
  error?: Error;
}

export default function reducer(
  state: AlternativeProjectsState = {
    items: [],
    isRequesting: false,
  },
  action:
    | AlternativeProjectsRequestAction
    | AlternativeProjectsSuccessAction
    | AlternativeProjectsFailureAction
): AlternativeProjectsState {
  switch (action.type) {
    case 'ALTERNATIVE_PROJECTS_REQUEST':
      return {
        ...state,
        isRequesting: true,
      };
    case 'ALTERNATIVE_PROJECTS_SUCCESS':
      return {
        ...state,
        isRequesting: false,
        items: action.payload,
      };
    case 'ALTERNATIVE_PROJECTS_FAILURE':
      return {
        ...state,
        isRequesting: false,
        error: action.payload,
      };
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/redux/modules/alternativeProjects.ts